import Spinner from '../../components/Spinner';
import React, { useEffect, useState } from 'react';
import api from '../../services/api';

function RegistroRapidoModal({ onCerrar, onGuardado }) {
  const [locos, setLocos] = useState([]);
  const [form, setForm] = useState({
    locomotora_id: '',
    fecha: new Date().toISOString().split('T')[0],
    km_odometro: '',
    litros_diesel: '',
    litros_adblue: '',
    horas_motor: '',
    observaciones: ''
  });
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get('/locomotoras/').then(r => setLocos(r.data.filter(l => l.activa)));
  }, []);

  const guardar = async () => {
    if (!form.locomotora_id) { setError('Selecciona una locomotora'); return; }
    setGuardando(true);
    setError(null);
    try {
      await api.post('/servicios/registro-rapido', {
        ...form,
        locomotora_id: parseInt(form.locomotora_id),
        km_odometro: form.km_odometro ? parseFloat(form.km_odometro) : null,
        litros_diesel: form.litros_diesel ? parseFloat(form.litros_diesel) : null,
        litros_adblue: form.litros_adblue ? parseFloat(form.litros_adblue) : null,
        horas_motor: form.horas_motor ? parseFloat(form.horas_motor) : null,
      });
      onGuardado();
    } catch (e) {
      setError('Error al guardar el registro');
    } finally {
      setGuardando(false);
    }
  };

  const campo = (label, key, type='number', placeholder='') => (
    <div style={{ marginBottom: 12 }}>
      <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>{label}</label>
      <input type={type} value={form[key]} onChange={e => setForm({...form, [key]: e.target.value})}
        placeholder={placeholder}
        style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box' }} />
    </div>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 28, width: 440, maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 600 }}>Registro rápido</h3>
          <button onClick={onCerrar} style={{ border: 'none', background: 'none', cursor: 'pointer', fontSize: 20, color: '#888' }}>×</button>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Locomotora</label>
          <select value={form.locomotora_id} onChange={e => setForm({...form, locomotora_id: e.target.value})}
            style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }}>
            <option value="">Seleccionar locomotora...</option>
            {locos.map(l => <option key={l.id} value={l.id}>{l.numero}</option>)}
          </select>
        </div>

        {campo('Fecha', 'fecha', 'date')}
        {campo('KM odómetro final', 'km_odometro', 'number', 'ej: 154223')}
        {campo('Litros diesel final', 'litros_diesel', 'number', 'ej: 3200')}
        {campo('Litros AdBlue final', 'litros_adblue', 'number', 'ej: 450')}
        {campo('Horas motor final', 'horas_motor', 'number', 'ej: 12450.5')}

        <div style={{ marginBottom: 12 }}>
          <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Observaciones</label>
          <textarea value={form.observaciones} onChange={e => setForm({...form, observaciones: e.target.value})}
            rows={2} placeholder="Opcional..."
            style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, boxSizing: 'border-box', resize: 'vertical' }} />
        </div>

        {error && <div style={{ background: '#fcebeb', border: '1px solid #e24b4a', borderRadius: 8, padding: '8px 12px', fontSize: 12, color: '#a32d2d', marginBottom: 12 }}>{error}</div>}

        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={guardar} disabled={guardando}
            style={{ flex: 1, padding: '10px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500, opacity: guardando ? 0.6 : 1 }}>
            {guardando ? 'Guardando...' : 'Guardar registro'}
          </button>
          <button onClick={onCerrar}
            style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Partes() {
  const [servicios, setServicios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [descargando, setDescargando] = useState({});
  const [modalEditar, setModalEditar] = useState(null);
  const [modalAnular, setModalAnular] = useState(null);
  const [form, setForm] = useState({});
  const [motivoAnulacion, setMotivoAnulacion] = useState('');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [filtro, setFiltro] = useState('activos');
  const [mostrarRegistroRapido, setMostrarRegistroRapido] = useState(false);
  const [filtros, setFiltros] = useState({ desde: '', hasta: '', maquinista: '', locomotora: '' });

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    setLoading(true);
    api.get('/servicios/').then(r => setServicios(r.data)).finally(() => setLoading(false));
  };

  const descargar = async (servicioId, tipo, nombre) => {
    setDescargando(prev => ({ ...prev, [`${servicioId}_${tipo}`]: true }));
    try {
      const res = await api.get(`/pdfs/servicio/${servicioId}/${tipo}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.download = nombre;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (e) {
      alert('Error al descargar el PDF');
    } finally {
      setDescargando(prev => ({ ...prev, [`${servicioId}_${tipo}`]: false }));
    }
  };

  const abrirEditar = (s) => {
    setModalEditar(s);
    setForm({
      base_mto: s.base_mto || '',
      km_inicio: s.km_inicio || '',
      km_fin: s.km_fin || '',
      litros_combustible_inicio: s.litros_combustible_inicio || '',
      litros_combustible_fin: s.litros_combustible_fin || '',
      toneladas_combustible: s.toneladas_combustible || '',
      horas_motor: s.horas_motor || '',
      observaciones: s.observaciones || '',
      descripcion: s.descripcion || '',
      exploracion_realizada: s.exploracion_realizada ?? true,
    });
  };

  const guardarEdicion = async () => {
    setSaving(true);
    try {
      const datos = {};
      Object.keys(form).forEach(k => {
        if (form[k] !== '' && form[k] !== null) {
          datos[k] = typeof form[k] === 'string' && !isNaN(form[k]) && k !== 'base_mto' && k !== 'observaciones' && k !== 'descripcion'
            ? parseFloat(form[k]) : form[k];
        }
      });
      await api.patch(`/servicios/${modalEditar.id}/editar`, datos);
      setMsg('Parte actualizado correctamente');
      setModalEditar(null);
      cargar();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      setMsg('Error al guardar');
    } finally {
      setSaving(false);
    }
  };

  const anular = async () => {
    setSaving(true);
    try {
      await api.patch(`/servicios/${modalAnular.id}/anular`, { motivo: motivoAnulacion });
      setMsg('Parte anulado');
      setModalAnular(null);
      setMotivoAnulacion('');
      cargar();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      setMsg('Error al anular');
    } finally {
      setSaving(false);
    }
  };

  const borrar = async (s) => {
    if (!window.confirm(`Borrar definitivamente el parte de ${s.locomotora} del ${new Date(s.fecha).toLocaleDateString('es-ES')}? Esta accion no se puede deshacer.`)) return;
    try {
      await api.delete(`/servicios/${s.id}`);
      setMsg('Parte eliminado');
      cargar();
      setTimeout(() => setMsg(''), 3000);
    } catch (e) {
      setMsg('Error al eliminar');
    }
  };

  const serviciosFiltrados = servicios.filter(s => {
    if (filtros.desde && s.fecha < filtros.desde) return false;
    if (filtros.hasta && s.fecha > filtros.hasta) return false;
    if (filtros.maquinista && !((s.maquinista_nombre || '') + ' ' + (s.maquinista_apellidos || '')).toLowerCase().includes(filtros.maquinista.toLowerCase())) return false;
    if (filtros.locomotora && !(s.locomotora || '').includes(filtros.locomotora)) return false;
    if (filtro === 'activos') return !s.anulado;
    if (filtro === 'anulados') return s.anulado;
    return true;
  });

  if (loading) return <Spinner />;

  return (
    <div>
      {mostrarRegistroRapido && (
        <RegistroRapidoModal
          onCerrar={() => setMostrarRegistroRapido(false)}
          onGuardado={() => { setMostrarRegistroRapido(false); cargar(); }}
        />
      )}
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <h2 style={{ fontSize: 22, fontWeight: 500, margin: 0 }}>Partes recibidos</h2>
        <p style={{ fontSize: 13, color: '#888', marginTop: 4 }}>Partes de trabajo enviados por los maquinistas</p>
      </div>
      <button onClick={() => setMostrarRegistroRapido(true)}
        style={{ padding: '9px 18px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 500, whiteSpace: 'nowrap' }}>
        + Registro rápido
      </button>

      {msg && <div style={{ background: '#eaf3de', border: '1px solid #97c459', borderRadius: 8, padding: '10px 16px', marginBottom: 16, fontSize: 13, color: '#3b6d11' }}>{msg}</div>}

      {/* Filtros */}
      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', padding: '12px 16px', marginBottom: 16, display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end' }}>
        <div>
          <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Desde</label>
          <input type="date" value={filtros.desde} onChange={e => setFiltros({...filtros, desde: e.target.value})}
            style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 12 }} />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Hasta</label>
          <input type="date" value={filtros.hasta} onChange={e => setFiltros({...filtros, hasta: e.target.value})}
            style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 12 }} />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Maquinista</label>
          <input placeholder="Nombre..." value={filtros.maquinista} onChange={e => setFiltros({...filtros, maquinista: e.target.value})}
            style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 12, width: 130 }} />
        </div>
        <div>
          <label style={{ display: 'block', fontSize: 11, color: '#555', marginBottom: 2 }}>Locomotora</label>
          <input placeholder="ej: 336001" value={filtros.locomotora} onChange={e => setFiltros({...filtros, locomotora: e.target.value})}
            style={{ padding: '6px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 12, width: 90 }} />
        </div>

        <button onClick={() => setFiltros({ desde: '', hasta: '', maquinista: '', locomotora: '' })}
          style={{ padding: '6px 12px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12, color: '#555' }}>
          Limpiar
        </button>
        <span style={{ fontSize: 12, color: '#888', alignSelf: 'center' }}>{serviciosFiltrados.length} resultados</span>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {[['activos', 'Activos'], ['anulados', 'Anulados'], ['todos', 'Todos']].map(([val, label]) => (
          <button key={val} onClick={() => setFiltro(val)} style={{
            padding: '7px 16px', borderRadius: 8, border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 500,
            background: filtro === val ? '#1a1a1a' : '#f0f0f0',
            color: filtro === val ? '#fff' : '#555'
          }}>{label}</button>
        ))}
      </div>

      <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e5e5e5', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#f8f8f6' }}>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Fecha</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Maquinista</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Locomotora</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>KM totales</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Estado</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>PDFs</th>
              <th style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 500, color: '#555' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {serviciosFiltrados.length === 0 && (
              <tr><td colSpan={7} style={{ padding: '24px', textAlign: 'center', color: '#aaa' }}>No hay partes</td></tr>
            )}
            {serviciosFiltrados.map(s => (
              <tr key={s.id} style={{ borderTop: '1px solid #f0f0f0', opacity: s.anulado ? 0.6 : 1 }}>
                <td style={{ padding: '10px 14px' }}>
                  {new Date(s.fecha).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                </td>
                <td style={{ padding: '10px 14px', fontWeight: 500 }}>{s.maquinista}</td>
                <td style={{ padding: '10px 14px' }}>{s.locomotora}</td>
                <td style={{ padding: '10px 14px' }}>{s.km_totales ? `${Math.round(s.km_totales)} km` : '—'}</td>
                <td style={{ padding: '10px 14px' }}>
                  {s.anulado
                    ? <span style={{ background: '#f0f0f0', color: '#888', border: '1px solid #ddd', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 500 }}>Anulado</span>
                    : <span style={{ background: '#eaf3de', color: '#3b6d11', border: '1px solid #97c459', borderRadius: 20, padding: '3px 10px', fontSize: 11, fontWeight: 500 }}>Activo</span>
                  }
                </td>
                <td style={{ padding: '10px 14px' }}>
                  {!s.anulado && (
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      <button onClick={() => descargar(s.id, 'checklist-previo', `checklist_previo_${s.locomotora}_${s.fecha?.slice(0,10)}.pdf`)}
                        disabled={descargando[`${s.id}_checklist-previo`]}
                        style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 11 }}>
                        {descargando[`${s.id}_checklist-previo`] ? '...' : 'Ch. Previo'}
                      </button>
                      <button onClick={() => descargar(s.id, 'parte-trabajo', `parte_trabajo_${s.locomotora}_${s.fecha?.slice(0,10)}.pdf`)}
                        disabled={descargando[`${s.id}_parte-trabajo`]}
                        style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 11 }}>
                        {descargando[`${s.id}_parte-trabajo`] ? '...' : 'Parte'}
                      </button>
                      <button onClick={() => descargar(s.id, 'checklist-final', `checklist_final_${s.locomotora}_${s.fecha?.slice(0,10)}.pdf`)}
                        disabled={descargando[`${s.id}_checklist-final`]}
                        style={{ padding: '4px 8px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 11 }}>
                        {descargando[`${s.id}_checklist-final`] ? '...' : 'Ch. Final'}
                      </button>
                    </div>
                  )}
                </td>
                <td style={{ padding: '10px 14px' }}>
                  <div style={{ display: 'flex', gap: 6 }}>
                    {!s.anulado && (
                      <>
                        <button onClick={() => abrirEditar(s)} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 12 }}>
                          Editar
                        </button>
                        <button onClick={() => { setModalAnular(s); setMotivoAnulacion(''); }} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #ef9f27', background: '#faeeda', cursor: 'pointer', fontSize: 12, color: '#854f0b' }}>
                          Anular
                        </button>
                      </>
                    )}
                    <button onClick={() => borrar(s)} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #fcc', background: '#fff5f5', cursor: 'pointer', fontSize: 12, color: '#c00' }}>
                      Borrar
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modalEditar && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}
          onClick={e => { if (e.target === e.currentTarget) setModalEditar(null); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 500, maxWidth: '95vw', maxHeight: '90vh', overflowY: 'auto' }}>
            <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 20 }}>
              Editar parte — {modalEditar.locomotora} · {new Date(modalEditar.fecha).toLocaleDateString('es-ES')}
            </h3>

            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Descripcion / Recorrido</label>
              <input value={form.descripcion} onChange={e => setForm({ ...form, descripcion: e.target.value })}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Base MTO</label>
              <input value={form.base_mto} onChange={e => setForm({ ...form, base_mto: e.target.value })}
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>KM inicio</label>
                <input type="number" value={form.km_inicio} onChange={e => setForm({ ...form, km_inicio: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>KM fin</label>
                <input type="number" value={form.km_fin} onChange={e => setForm({ ...form, km_fin: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Litros combustible inicio</label>
                <input type="number" value={form.litros_combustible_inicio} onChange={e => setForm({ ...form, litros_combustible_inicio: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Litros combustible fin</label>
                <input type="number" value={form.litros_combustible_fin} onChange={e => setForm({ ...form, litros_combustible_fin: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Toneladas combustible</label>
                <input type="number" value={form.toneladas_combustible} onChange={e => setForm({ ...form, toneladas_combustible: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Horas motor</label>
                <input type="number" value={form.horas_motor} onChange={e => setForm({ ...form, horas_motor: e.target.value })}
                  style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13 }} />
              </div>
            </div>

            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Exploracion realizada</label>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => setForm({ ...form, exploracion_realizada: true })} style={{
                  flex: 1, padding: '8px', borderRadius: 8, border: `2px solid ${form.exploracion_realizada ? '#3b6d11' : '#ddd'}`,
                  background: form.exploracion_realizada ? '#eaf3de' : '#fff', cursor: 'pointer', fontSize: 13,
                  color: form.exploracion_realizada ? '#3b6d11' : '#555', fontWeight: 500
                }}>✓ Si</button>
                <button onClick={() => setForm({ ...form, exploracion_realizada: false })} style={{
                  flex: 1, padding: '8px', borderRadius: 8, border: `2px solid ${!form.exploracion_realizada ? '#a32d2d' : '#ddd'}`,
                  background: !form.exploracion_realizada ? '#fcebeb' : '#fff', cursor: 'pointer', fontSize: 13,
                  color: !form.exploracion_realizada ? '#a32d2d' : '#555', fontWeight: 500
                }}>✗ No</button>
              </div>
            </div>

            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Observaciones</label>
              <textarea value={form.observaciones} onChange={e => setForm({ ...form, observaciones: e.target.value })}
                rows={3} style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, resize: 'none', boxSizing: 'border-box' }} />
            </div>

            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setModalEditar(null)} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
              <button onClick={guardarEdicion} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#1a1a1a', color: '#fff', cursor: 'pointer', fontSize: 13, opacity: saving ? 0.7 : 1 }}>
                {saving ? 'Guardando...' : 'Guardar cambios'}
              </button>
            </div>
          </div>
        </div>
      )}

      {modalAnular && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200 }}
          onClick={e => { if (e.target === e.currentTarget) setModalAnular(null); }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, width: 400, maxWidth: '95vw' }}>
            <h3 style={{ fontSize: 16, fontWeight: 500, marginBottom: 6 }}>Anular parte</h3>
            <p style={{ fontSize: 13, color: '#888', marginBottom: 16 }}>
              {modalAnular.locomotora} · {new Date(modalAnular.fecha).toLocaleDateString('es-ES')}
            </p>
            <div style={{ marginBottom: 20 }}>
              <label style={{ display: 'block', fontSize: 12, color: '#555', marginBottom: 4 }}>Motivo de anulacion (opcional)</label>
              <textarea value={motivoAnulacion} onChange={e => setMotivoAnulacion(e.target.value)}
                rows={3} placeholder="Indica el motivo..."
                style={{ width: '100%', padding: '8px 10px', borderRadius: 8, border: '1px solid #ddd', fontSize: 13, resize: 'none', boxSizing: 'border-box' }} />
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setModalAnular(null)} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
              <button onClick={anular} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: '#854f0b', color: '#fff', cursor: 'pointer', fontSize: 13, opacity: saving ? 0.7 : 1 }}>
                {saving ? 'Anulando...' : 'Anular parte'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
